export default __webpack_public_path__ + "static/media/passed.27d33766.svg";